import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  SubscriptionChangeDialogComponent
} from '@client/shared/components/subscription/subscription-change-dialog/subscription-change-dialog.component';
import { BaseComponent } from '@shared/component/base/base.component';

@Component({
  selector: 'app-subscription-banner-upgrade',
  templateUrl: './subscription-banner-upgrade.component.html',
  styleUrls: ['./subscription-banner-upgrade.component.scss'],
  standalone: false
})
export class SubscriptionBannerUpgradeComponent extends BaseComponent {
  constructor(private dialog: MatDialog) {
    super();
  }

  openSubscriptionDialog(): void {
    this.dialog.open(SubscriptionChangeDialogComponent, {
      panelClass: 'dialog-extra-large'
    });
  }
}
